<template>
  <div class="mds-tag">
    <strong>{{ type }}: </strong> {{ label }}
    <button
      class="mds-button mds-button--icon-only mds-tag--dismissible__button"
      type="button"
      @click="$emit('closeItem', label)"
    >
      <svg class="mds-icon mds-button__icon mds-button__icon--left">
        <use xlink:href="static/mds/icons/mds.svg#remove--s">
          <title>Remove filter</title>
        </use>
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  name: 'filterItem',
  data() {
    return {};
  },
  props: ['label', 'type'],
};
</script>
